<ng-container *transloco="let t">
  <div class="wrap" [class.gray-bg]="enableGrayBackground">
    <div class="page">
      <div class="page-main">
        <app-sidebar appHoverEffectSidebar></app-sidebar>

        <div class="app-content main-content">
          <app-info-banner *ngIf="isDemoKindergarten" type="demo"></app-info-banner>
          <app-info-banner *ngIf="licenseBanner" [type]="licenseBanner.type" [daysLeft]="licenseBanner.daysLeft"></app-info-banner>

          <div class="lockable-area" [class.locked]="showPapLockOverlay">
            <ng-container *ngIf="showPapLockOverlay">
              <app-license-lock-modal
                [contained]="true"
                [title]="t('pap/lock/title')"
                [text]="t('pap/lock/text', { module: '<strong>' + t('pap/lock/moduleName') + '</strong>' })"
              ></app-license-lock-modal>
            </ng-container>

            <app-header></app-header>
            <div class="side-app main-container" [class.content-hidden]="isPapLockCheckPending && isCurrentRouteLockable">
              <router-outlet *ngIf="!(isPapLockCheckPending && isCurrentRouteLockable)"></router-outlet>
            </div>
          </div>
        </div>

        <app-footer></app-footer>

        <div class="alert alert-warning sticky-footer text-center" role="alert" *ngIf="(licenses$ | async)?.premium === false">
          {{ t('shared/freeVersion') }}
          <a href="https://eshop.isophi.cz/produkt/rodicovska-povidla" target="_blank" class="btn btn-warning ml-2">{{
            t('shared/buyPremium')
          }}</a>
        </div>
      </div>
    </div>
  </div>
</ng-container>
